import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import pino from 'pino';

const privacyLevel = import.meta.env.VITE_DD_RUM_PRIV_LEVEL ?? 'mask-unless-allowlisted';

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  defaultPrivacyLevel: ['allow', 'mask', 'mask-user-input', 'mask-unless-allowlisted'].includes(privacyLevel)
    ? privacyLevel
    : 'mask-unless-allowlisted',
  env: import.meta.env.VITE_ENVIRONMENT,
  plugins: [reactPlugin({ router: true })],
  service: import.meta.env.VITE_SERVICE_NAME,
  sessionReplaySampleRate: 100,
  sessionSampleRate: 100,
  site: 'ddog-gov.com',
  trackLongTasks: true,
  trackResources: true,
  trackUserInteractions: true,
  version: import.meta.env.VITE_VERSION,
});

const logger = pino({
  level: process.env.NODE_ENV === 'production' ? 'info' : 'debug',
});

export default logger;
